import { Box } from '@chakra-ui/react';
import React from 'react';

import { LOCALES, type Locale, type TranslationKey } from 'lib/i18n/types';

import { useI18n } from 'lib/contexts/i18n';
import { Button, ButtonGroupRadio } from 'toolkit/chakra/button';

const LANGUAGE_LABEL_KEYS: Record<Locale, TranslationKey> = {
  en: 'language.english',
  'zh-CN': 'language.simplified_chinese',
  'zh-TW': 'language.traditional_chinese',
};

const SettingsLanguage = () => {
  const { locale, setLocale, t } = useI18n();

  const handleLocaleChange = React.useCallback((value: string) => {
    setLocale(value as Locale);
  }, [ setLocale ]);

  return (
    <Box borderColor="border.divider" borderTopWidth="1px" mt={ 3 } pt={ 3 }>
      <Box fontWeight={ 600 } mb={ 2 }>{ t('language.label') }</Box>
      <ButtonGroupRadio
        key={ locale }
        defaultValue={ locale }
        onChange={ handleLocaleChange }
        equalWidth
        size="sm"
        w="100%"
      >
        { LOCALES.map((item) => (
          <Button key={ item } value={ item }>
            { t(LANGUAGE_LABEL_KEYS[item]) }
          </Button>
        )) }
      </ButtonGroupRadio>
    </Box>
  );
};

export default React.memo(SettingsLanguage);
